import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAdmin } from '../hooks/useAdmin';
import { useAuth } from '../hooks/useAuth';
import { ref, onValue, set, update, get } from 'firebase/database';
import { database, db } from '../firebase';
import { doc, getDoc, collection, addDoc, serverTimestamp, collectionGroup, getDocs } from 'firebase/firestore';
import AdminSeedUniversities from './AdminSeedUniversities';
import LicenseAdminPanel from './LicenseAdminPanel';
import NotificationAdminPanel from './NotificationAdminPanel';
import TemporaryAdminPanel from './TemporaryAdminPanel';
import AdminSettingsModal from './AdminSettingsModal';
import DeviceAdminPanel from './DeviceAdminPanel';
import RTDBViewerPanel from './RTDBViewerPanel';
import VersionTrackingPanel from './VersionTrackingPanel';
import ManualRegisterPanel from './ManualRegisterPanel';
import WebLicenseAdmin from './WebLicenseAdmin';
import AnniversaryAdminPanel from './AnniversaryAdminPanel';
import YouTubeDownloaderPanel from './YouTubeDownloaderPanel';
import AdminTutorialsPanel from './AdminTutorialsPanel';
import UserLicenseManagementPanel from './UserLicenseManagementPanel';
import AdminAssignProfilePanel from './AdminAssignProfilePanel';
import AdminRebuildPreguntasPorTema from './AdminRebuildPreguntasPorTema';
import AdminOCRPanel from './AdminOCRPanel';
import AdminLicensesPanel from './AdminLicensesPanel';
import AdminStudyMaterial from './AdminStudyMaterial';
import AdminLiveUsersPanel from './AdminLiveUsersPanel';
import AdminShadowPanel from './AdminShadowPanel';
import AdminCursosManagement from './AdminCursosManagement';
import AdminAssignVault from './AdminAssignVault';
import '../styles/AdminPanel.css';
import '../styles/AdminDesignSystem.css';

const initialCategories = [
    {
        title: 'Acciones Rápidas',
        icon: '⚡',
        fullWidth: true,
        twoColumns: true,
        items: [
            { id: 'live-users', label: 'Monitor Usuarios en Vivo', icon: '🛰️', description: 'Supervisar usuarios conectados en tiempo real (Web y App Vortex).' },
            {
                id: 'quizzes',
                label: 'Gestor de Quizzes',
                icon: '📝',
                description: 'Áreas, Temas y Preguntas.',
                route: '/dashboard/admin/quizz-management'
            },
            { id: 'licenses-consolidated', label: 'Reactivar Licencia', icon: '✅', description: 'Acceso rápido a activación de licencias.' },
        ]
    },
    {
        title: 'Gestión de Usuarios',
        icon: '👥',
        twoColumns: true,
        items: [
            { id: 'live-users', label: 'Usuarios en Vivo (Web y App)', icon: '🛰️', description: 'Ver qué usuarios están activos ahora mismo en la Web o en la App Vortex Móvil.' },
            { id: 'licenses-consolidated', label: 'Control de Accesos y Licencias', icon: '📋', description: 'Buscar, activar, extender licencias web/móvil, registro manual y limpieza.' },
            { id: 'devices', label: 'Gestión de Dispositivos', icon: '📱', description: 'Ver y resetear dispositivos vinculados.' },
            { id: 'assign-profile', label: 'Asignar Perfil', icon: '📋', description: 'Asignar jerarquía, cuerpo y especialidad a usuarios.' },
            { id: 'shadow', label: 'Modo Shadow (Soporte)', icon: '🕵️', description: 'Inspeccionar perfil, licencias, dispositivos y quizzes de cualquier usuario.' },
        ]
    },
    {
        title: 'Academia Vortex',
        icon: '🎓',
        twoColumns: true,
        items: [
            {
                id: 'cursos-vortex-admin',
                label: 'Gestor Cursos Vortex',
                icon: '🎓',
                description: 'Administrar cursos navales, lecciones, quices, PDFs, periodos y pasarela de pago.',
                route: '/dashboard/admin/cursos'
            },
            {
                id: 'lector-temas-admin',
                label: 'Lector de Temas',
                icon: '📖',
                description: 'Automatizar y editar páginas de lectura (Lector Vortex Academy) por especialidad.',
                route: '/dashboard/admin/lector-temas'
            },
            {
                id: 'cursos-catalog-preview',
                label: 'Catálogo de Cursos (Vista Estudiante)',
                icon: '👁️',
                description: 'Explorar la plataforma e interfaz pública de Cursos Vortex.',
                route: '/cursos'
            }
        ]
    },
    {
        title: 'Contenido y Cuestionarios',
        icon: '📚',
        twoColumns: true,
        items: [
            { id: 'notifications', label: 'Notificaciones Globales', icon: '🔔', description: 'Enviar avisos y mensajes a la app.' },
            {
                id: 'vortex-docs',
                label: 'Generador Vortex Docs',
                icon: '📄',
                description: 'Crear resúmenes y cuestionarios con IA.',
                route: '/dashboard/admin/vortex-docs',
            },
        
            {
                id: 'yt-downloader',
                label: 'YouTube Downloader Pro',
                icon: '🎬',
                description: 'Descargar y convertir videos de YouTube (Admin).'
            },
            {
                id: 'tutorials-admin',
                label: 'Gestor de Videotutoriales',
                icon: '🎥',
                description: 'Administrar videos y subir a Cloudflare R2.'
            },
            {
                id: 'ocr-scanner',
                label: 'Escáner OCR',
                icon: '📄',
                description: 'Extraer texto de imágenes y PDFs escaneados con OCR.'
            },
            
        ]
    },
{
            title: 'Configuración Técnica',
            icon: '⚙️',
            twoColumns: true,
            items: [
                { id: 'rtdb', label: 'RTDB Explorer', icon: '🗄️', description: 'Navegador de datos en tiempo real.' },
                { id: 'versions', label: 'Tracking de Versiones', icon: '📈', description: 'Ver versiones usadas por los usuarios.' },
                { id: 'anniversary', label: 'Activación Aniversario', icon: '🎉', description: 'Activar/Desactivar banner de aniversario.' },
                { id: 'maintenance', label: 'Ajustes y Mantenimiento', icon: '🛠️', description: 'Reglas globales, control de usuarios y mantenimiento del sistema.', route: '/dashboard/admin/maintenance' },
                { id: 'seed-universities', label: 'Sembrar Universidades/Carreras', icon: '🌱', description: 'Poblar RTDB con universidades, carreras y módulos EXANI-II.' },
                { id: 'health-check', label: 'Diagnóstico del Sistema', icon: '🛡️', description: 'Auditoría en tiempo real de Firebase, IndexedDB y las 28 pantallas del Dashboard.', route: '/dashboard/admin/health-check' },
            ]
        }
];

const AdminPanel = () => {
    const { user } = useAuth();
    const { isAdmin, loading } = useAdmin(user);
    const navigate = useNavigate();

    const location = useLocation();
    
    // Leer el parámetro ?panel de la URL
    const searchParams = new URLSearchParams(location.search);
    const panelFromUrl = searchParams.get('panel');

    // Estados básicos
    const [activeTab, setActiveTab] = useState(panelFromUrl || 'dashboard');

    // Estados de Modo de Vista (Cuadrícula / Lista) y Filtros de Búsqueda
    const [viewMode, setViewMode] = useState(() => localStorage.getItem('adminViewMode') || 'grid'); // 'grid' | 'list'
    const [selectedCategoryFilter, setSelectedCategoryFilter] = useState('ALL');
    const [searchTerm, setSearchTerm] = useState('');

    const handleViewModeChange = (mode) => {
        setViewMode(mode);
        localStorage.setItem('adminViewMode', mode);
    };

    const getCategoryBadgeClass = (categoryTitle = '') => {
        if (categoryTitle.includes('Acciones')) return 'acciones';
        if (categoryTitle.includes('Usuarios')) return 'usuarios';
        if (categoryTitle.includes('Academia')) return 'academia';
        if (categoryTitle.includes('Contenido')) return 'contenido';
        if (categoryTitle.includes('Técnica') || categoryTitle.includes('Tecnica')) return 'tecnica';
        return 'acciones';
    };

    useEffect(() => {
        if (panelFromUrl) {
            setActiveTab(panelFromUrl);
        } else {
            setActiveTab('dashboard');
        }
    }, [panelFromUrl]);
    const [adminEnabled, setAdminEnabled] = useState(true);
    const [isUpdatingDb, setIsUpdatingDb] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [anniversaryActive, setAnniversaryActive] = useState(false);

    // Estados de personalización
    const [textColor, setTextColor] = useState(localStorage.getItem('adminTextColor') || '#FFFFFF');
    const [btnColor, setBtnColor] = useState(localStorage.getItem('adminBtnColor') || '#2196F3');
    const [backgroundId, setBackgroundId] = useState(parseInt(localStorage.getItem('adminBgId')) || 13);
    // State for user quizzes management
    const [usersList, setUsersList] = useState([]);
    const [selectedUid, setSelectedUid] = useState('');
    const [userQuizzes, setUserQuizzes] = useState([]);
    const [userQuizzesLoading, setUserQuizzesLoading] = useState(false);
    const [userQuizzesError, setUserQuizzesError] = useState('');
    const [selectedQuizKey, setSelectedQuizKey] = useState('');
    const [quizQuestions, setQuizQuestions] = useState([]);
    const [quizQuestionsLoading, setQuizQuestionsLoading] = useState(false);
    const [quizQuestionsError, setQuizQuestionsError] = useState('');
    const [exportMessage, setExportMessage] = useState('');
    const [exportQuizName, setExportQuizName] = useState('');
    const [exportProgress, setExportProgress] = useState(0);
    const [isExporting, setIsExporting] = useState(false);

    // Estados de Drag & Drop
    const [categories, setCategories] = useState(() => {
        const saved = localStorage.getItem('adminDashboardLayout');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                // Sincronizar categorías y elementos
                return initialCategories.map(freshCat => {
                    const savedCat = parsed.find(c => c.title === freshCat.title);
                    if (!savedCat) return freshCat;

                    // Mezclar elementos: mantener orden de los guardados, añadir nuevos de freshCat
                    const mergedItems = [...savedCat.items];

                    freshCat.items.forEach(freshItem => {
                        const exists = mergedItems.some(i => i.id === freshItem.id);
                        if (!exists) {
                            mergedItems.push(freshItem);
                        }
                    });

                    // Actualizar etiquetas y descripciones de elementos existentes
                    return {
                        ...freshCat,
                        items: mergedItems.map(item => {
                            const freshItem = freshCat.items.find(i => i.id === item.id);
                            if (!freshItem) return item;
                            return {
                                ...item,
                                label: freshItem.label,
                                description: freshItem.description,
                                route: freshItem.route,
                                icon: freshItem.icon
                            };
                        })
                    };
                });
            } catch (e) {
                return initialCategories;
            }
        }
        return initialCategories;
    });

    const [draggedItem, setDraggedItem] = useState(null);
    const [draggedCategory, setDraggedCategory] = useState(null);
    const [dragOverCategoryIdx, setDragOverCategoryIdx] = useState(null);

    useEffect(() => {
        // Verificar si el panel está habilitado globalmente
        const configRef = ref(database, 'appConfig/admin_panel_enabled');
        const unsub = onValue(configRef, (snapshot) => {
            if (snapshot.exists()) {
                setAdminEnabled(snapshot.val());
            }
        });

        // Verificar si el aniversario está activado
        const anniversaryRef = ref(database, 'appConfig/anniversary_active');
        const unsubAnniversary = onValue(anniversaryRef, (snapshot) => {
            setAnniversaryActive(snapshot.val() || false);
        });

        // Aplicar variables CSS para personalización
        document.documentElement.style.setProperty('--admin-text-custom', textColor);
        document.documentElement.style.setProperty('--admin-btn-custom', btnColor);

        return () => {
            unsub();
            unsubAnniversary();
        };
    }, [textColor, btnColor]);
    // Fetch list of users with quizzes from Firestore when tab is active
    useEffect(() => {
        if (activeTab !== 'user-quizzes') return;
        
        const loadUsersWithQuizzes = async () => {
            try {
                const quizzesSnap = await getDocs(collectionGroup(db, 'quizzes'));
                const uids = new Set();
                quizzesSnap.forEach(docSnap => {
                    const pathSegments = docSnap.ref.path.split('/');
                    // Only consider documents under user_quizzes/{uid}/quizzes
                    if (pathSegments.length >= 3 && pathSegments[0] === 'user_quizzes') {
                        uids.add(pathSegments[1]);
                    }
                });

                const usersData = [];
                for (const uid of uids) {
                    if (!uid) continue;
                    const userSnap = await getDoc(doc(db, 'users', uid));
                    let name = 'Usuario';
                    // Raw values (as stored in Firestore)
                    let gradoRaw = '';
                    let cuerpoServicioRaw = '';
                    let especialidadRaw = '';

                    if (userSnap.exists()) {
                        const data = userSnap.data();
                        // Nombre
                        name = data.name || data.nombre || 'Usuario';
                        // Grado / Jerarquía: campo principal en Firestore es 'grado'
                        gradoRaw = data.grado || data.hierarchy || data.jerarquia || '';
                        // Cuerpo / Servicio: campo principal en Firestore es 'cuerpoServicio'
                        cuerpoServicioRaw = data.cuerpoServicio || data.cuerpo_servicio || data.cuerpo || data.corps || '';
                        // Especialidad: campo principal en Firestore es 'especialidad'
                        especialidadRaw = data.especialidad || data.specialty || '';
                    }

                    usersData.push({
                        uid,
                        name,
                        gradoRaw,
                        cuerpoServicioRaw,
                        especialidadRaw,
                        // Códigos normalizados para comparación y etiquetas
                        hierarchy:    translateHierarchy(gradoRaw),
                        corpsCode:    translateCorps(cuerpoServicioRaw),
                        specialtyCode: translateSpecialty(especialidadRaw)
                    });
                }
                setUsersList(usersData);
            } catch (err) {
                console.error("Error loading users with quizzes:", err);
            }
        };

        loadUsersWithQuizzes();
    }, [activeTab]);

    // Fetch quizzes for selected user from Firestore
    useEffect(() => {
        if (!selectedUid) {
            setUserQuizzes([]);
            setSelectedQuizKey('');
            setQuizQuestions([]);
            return;
        }
        setUserQuizzesLoading(true);
        setUserQuizzesError('');
        const loadUserQuizzes = async () => {
            try {
                const quizzesSnap = await getDocs(collection(db, 'user_quizzes', selectedUid, 'quizzes'));
                const quizzes = [];
                quizzesSnap.forEach(docSnap => {
                    quizzes.push({
                        id: docSnap.id,
                        ...docSnap.data()
                    });
                });
                setUserQuizzes(quizzes);
            } catch (err) {
                console.error("Error loading user quizzes:", err);
                setUserQuizzesError('Error al cargar cuestionarios: ' + err.message);
            } finally {
                setUserQuizzesLoading(false);
            }
        };
        loadUserQuizzes();
    }, [selectedUid]);

    // Fetch questions for selected quiz
    useEffect(() => {
        if (!selectedUid || !selectedQuizKey) {
            setQuizQuestions([]);
            setQuizQuestionsError('');
            return;
        }
        setQuizQuestionsLoading(true);
        setQuizQuestionsError('');
        const loadQuizQuestions = async () => {
            try {
                const questionsSnap = await getDocs(collection(db, 'user_quizzes', selectedUid, 'quizzes', selectedQuizKey, 'questions'));
                let questions = [];
                questionsSnap.forEach(docSnap => {
                    questions.push({
                        id: docSnap.id,
                        ...docSnap.data()
                    });
                });
                // If subcollection empty, check for inline questions in quiz document
                if (questions.length === 0) {
                    const quizDoc = await getDoc(doc(db, 'user_quizzes', selectedUid, 'quizzes', selectedQuizKey));
                    if (quizDoc.exists()) {
                        const data = quizDoc.data();
                        if (Array.isArray(data.questions)) {
                            questions = data.questions;
                        } else if (Array.isArray(data.preguntas)) {
                            questions = data.preguntas;
                        }
                    }
                }
                setQuizQuestions(questions);
                if (questions.length === 0) {
                    setQuizQuestionsError('Este cuestionario no tiene preguntas disponibles.');
                }
            } catch (err) {
                console.error("Error loading quiz questions:", err);
                setQuizQuestionsError('Error al cargar preguntas: ' + err.message);
            } finally {
                setQuizQuestionsLoading(false);
            }
        };
        loadQuizQuestions();
    }, [selectedUid, selectedQuizKey]);

    useEffect(() => {
        if (selectedQuizKey && userQuizzes.length > 0) {
            const quizObj = userQuizzes.find(q => q.id === selectedQuizKey);
            if (quizObj) {
                setExportQuizName(quizObj.name || quizObj.titulo || quizObj.id || '');
            }
        } else {
            setExportQuizName('');
        }
    }, [selectedQuizKey, userQuizzes]);

    if (loading) {
        return (
            <div className="admin-loading">
                <div className="loading-spinner"></div>
                <p>Verificando permisos de administrador...</p>
            </div>
        );
    }

    if (!adminEnabled) {
        return (
            <div className="admin-disabled-overlay">
                <div className="disabled-card">
                    <h1>Panel deshabilitado</h1>
                    <p>Esta sección está temporalmente deshabilitada por configuración remota.</p>
                    <button onClick={() => navigate('/dashboard')}>Volver al Panel de Usuario</button>
                </div>
            </div>
        );
    }

    if (!isAdmin) {
        return (
            <div className="admin-access-denied">
                <div className="access-denied-icon">🚫</div>
                <h2>Acceso Denegado</h2>
                <p>No tienes permisos de administrador para acceder a esta sección.</p>
                <button onClick={() => navigate('/dashboard')} className="back-btn">Regresar</button>
            </div>
        );
    }

    const handleToggleAnniversary = async () => {
        const newValue = !anniversaryActive;
        try {
            await set(ref(database, 'appConfig/anniversary_active'), newValue);
            alert(`Aniversario ${newValue ? 'ACTIVADO' : 'DESACTIVADO'} correctamente.`);
        } catch (error) {
            console.error("Error toggling anniversary:", error);
            alert("Error al cambiar el estado del aniversario.");
        }
    };


    const handleDragStartItem = (e, item, sourceCategoryIdx, itemIdx) => {
        setDraggedItem({ item, sourceCategoryIdx, itemIdx });
        setDraggedCategory(null);
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", item.id);
    };

    const handleDragOverCategory = (e, categoryIdx) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = "move";
        if (dragOverCategoryIdx !== categoryIdx) {
            setDragOverCategoryIdx(categoryIdx);
        }
    };

    const handleDragLeaveCategory = (e, categoryIdx) => {
        e.preventDefault();
        if (dragOverCategoryIdx === categoryIdx) {
            setDragOverCategoryIdx(null);
        }
    };

    const handleDropOnCategory = (e, targetCategoryIdx) => {
        e.preventDefault();
        setDragOverCategoryIdx(null);

        // Si se está moviendo una categoría completa
        if (draggedCategory !== null) {
            if (draggedCategory === targetCategoryIdx) return;
            const newCategories = [...categories];
            const [movedCategory] = newCategories.splice(draggedCategory, 1);
            newCategories.splice(targetCategoryIdx, 0, movedCategory);

            setCategories(newCategories);
            localStorage.setItem('adminDashboardLayout', JSON.stringify(newCategories));
            setDraggedCategory(null);
            return;
        }

        // Si se está moviendo una tarjeta de herramienta entre o dentro de categorías
        if (!draggedItem) return;

        const newCategories = categories.map(cat => ({ ...cat, items: [...cat.items] }));
        const sourceCat = newCategories[draggedItem.sourceCategoryIdx];
        const targetCat = newCategories[targetCategoryIdx];

        if (!sourceCat || !targetCat) return;

        const sourceItemIdx = sourceCat.items.findIndex(i => i.id === draggedItem.item.id);
        if (sourceItemIdx === -1) return;

        // Extraer tarjeta de origen
        const [movedItem] = sourceCat.items.splice(sourceItemIdx, 1);

        // Insertar al final de la categoría destino
        targetCat.items.push(movedItem);

        setCategories(newCategories);
        localStorage.setItem('adminDashboardLayout', JSON.stringify(newCategories));
        setDraggedItem(null);
    };

    const handleDropOnItem = (e, targetItem, targetCategoryIdx, targetItemIdx) => {
        e.stopPropagation();
        e.preventDefault();
        setDragOverCategoryIdx(null);

        if (!draggedItem) return;
        if (draggedItem.item.id === targetItem.id) return;

        const newCategories = categories.map(cat => ({ ...cat, items: [...cat.items] }));
        const sourceCat = newCategories[draggedItem.sourceCategoryIdx];
        const targetCat = newCategories[targetCategoryIdx];

        if (!sourceCat || !targetCat) return;

        const sourceItemIdx = sourceCat.items.findIndex(i => i.id === draggedItem.item.id);
        if (sourceItemIdx === -1) return;

        const [movedItem] = sourceCat.items.splice(sourceItemIdx, 1);

        let insertIdx = targetCat.items.findIndex(i => i.id === targetItem.id);
        if (insertIdx === -1) insertIdx = targetCat.items.length;

        targetCat.items.splice(insertIdx, 0, movedItem);

        setCategories(newCategories);
        localStorage.setItem('adminDashboardLayout', JSON.stringify(newCategories));
        setDraggedItem(null);
    };

    const handleDragStartCategory = (e, idx) => {
        setDraggedCategory(idx);
        setDraggedItem(null);
        e.dataTransfer.effectAllowed = "move";
    };

    const handleResetLayout = () => {
        if (window.confirm("¿Deseas restablecer el orden original de las categorías y herramientas del panel de administración?")) {
            setCategories(initialCategories);
            localStorage.removeItem('adminDashboardLayout');
        }
    };

    const translateHierarchy = (h) => {
        if (!h) return 'MRO';
        const normalized = h.replace(/_/g, ' ').trim().toLowerCase();
        const map = {
            'marinero': 'MRO',
            'cabo': 'CABO',
            'tercer maestre': '3ER.MTRE',
            'segundo maestre': '2DO.MTRE',
            'primer maestre': '1RM',
            'teniente de corbeta': 'TTE.CORB',
            'teniente de fragata': 'TTE.FRAG',
            'teniente de navío': 'TTE.NAV',
            'teniente de navio': 'TTE.NAV',
            'capitán de corbeta': 'CAP.CORB',
            'capitan de corbeta': 'CAP.CORB',
            'teniente': 'TTE',
            'capitán': 'CAP'
        };
        return map[normalized] || h.toUpperCase();
    };

    const translateCorps = (corps) => {
        if (!corps) return 'SAIN';
        const normalized = corps.trim().toLowerCase();
        const map = {
            'cuerpo general': 'CGEN',
            'infantería de marina': 'IM',
            'infanteria de marina': 'IM',
            'aeronáutica naval': 'AN',
            'aeronautica naval': 'AN',
            'servicio de administración e intendencia naval': 'SAIN',
            'servicio de intendencia naval': 'SAIN',
            'servicio de intendencia': 'SAIN',
            'servicio de sanidad naval': 'SSN',
            'servicio de sanidad': 'SSN',
            'servicio de ingenieros de la armada': 'SIA.ING',
            'servicio de mantenimiento a aeronaves': 'MAA',
            'servicio de comunicaciones navales': 'SCN',
            'servicio de comunicaciones': 'COMP',
            'servicio de máquinas navales': 'CG.MAQS',
            'servicio de maquinas navales': 'CG.MAQS',
            'servicio de máquinas': 'MAQ',
            'servicio de maquinas': 'MAQ',
            'servicio de informática naval': 'INF',
            'servicio de informatica naval': 'INF',
            'servicio médico': 'L.MED',
            'servicio medico': 'L.MED',
            'servicio de justicia naval': 'SJN',
            'servicio de justicia': 'SJN',
            'servicio de docencia naval': 'SDN'
        };
        return map[normalized] || corps.toUpperCase();
    };

    const translateSpecialty = (specialty) => {
        if (!specialty) return 'OFTA';
        const normalized = specialty.trim().toLowerCase();
        const map = {
            'oficinista': 'OFTA',
            'oficinistas': 'OFTA',
            'lavandería': 'LAVD',
            'lavanderia': 'LAVD',
            'cocina': 'COCN',
            'armamento': 'ARMM',
            'navegación': 'NAVG',
            'navegacion': 'NAVG',
            'condestable': 'COND',
            'mecánico': 'MEC',
            'mecanico': 'MEC',
            'electricista': 'ELEC',
            'electrónica': 'ELTC',
            'electronica': 'ELTC'
        };
        return map[normalized] || specialty.toUpperCase();
    };

    const handleExportQuiz = async () => {
        if (!selectedUid || !selectedQuizKey) {
            setExportMessage('Seleccione un usuario y un cuestionario.');
            return;
        }
        setExportMessage('Procesando exportación...');
        setIsExporting(true);
        setExportProgress(0);

        try {
            const adminUid = user?.uid;

            // 1. Obtener perfil del Admin (Firestore y RTDB fallback)
            const adminDocSnap = await getDoc(doc(db, 'users', adminUid));
            let adminData = adminDocSnap.exists() ? adminDocSnap.data() : {};
            const adminRtdbSnap = await get(ref(database, `users/${adminUid}`));
            const adminRtdb = adminRtdbSnap.val() || {};

            const adminH = adminData.hierarchy || adminData.jerarquia || adminData.grado || adminRtdb.hierarchy || adminRtdb.jerarquia || adminRtdb.grado;
            const adminC = adminData.corps || adminData.cuerpoServicio || adminData.cuerpo || adminRtdb.corps || adminRtdb.cuerpoServicio || adminRtdb.cuerpo || adminRtdb.cuerpo_y_servicio;
            const adminS = adminData.specialty || adminData.especialidad || adminRtdb.specialty || adminRtdb.especialidad;

            // 2. Obtener perfil del Usuario (Firestore y RTDB fallback)
            const userDocSnap = await getDoc(doc(db, 'users', selectedUid));
            let userData = userDocSnap.exists() ? userDocSnap.data() : {};
            const userRtdbSnap = await get(ref(database, `users/${selectedUid}`));
            const userRtdb = userRtdbSnap.val() || {};

            const userH = userData.hierarchy || userData.jerarquia || userData.grado || userRtdb.hierarchy || userRtdb.jerarquia || userRtdb.grado;
            const userC = userData.corps || userData.cuerpoServicio || userData.cuerpo || userRtdb.corps || userRtdb.cuerpoServicio || userRtdb.cuerpo || userRtdb.cuerpo_y_servicio;
            const userS = userData.specialty || userData.especialidad || userRtdb.specialty || userRtdb.especialidad;

            // Traducir jerarquías, cuerpo y especialidad del creador del cuestionario
            const userHCode = translateHierarchy(userH);
            const userCCode = translateCorps(userC);
            const userSCode = translateSpecialty(userS);

            // 3. Obtener el cuestionario del usuario de Firestore
            const quizDocSnap = await getDoc(doc(db, 'user_quizzes', selectedUid, 'quizzes', selectedQuizKey));
            const quizData = quizDocSnap.exists() ? quizDocSnap.data() : null;
            if (!quizData) {
                setExportMessage('El cuestionario no existe o no tiene datos.');
                setIsExporting(false);
                return;
            }

            const themeCode = (quizData.themeCode || quizData.temaName || 'GENERAL').toUpperCase().replace(/\s/g, '_');
            const standardizedId = `${userHCode}.${userCCode}.${userSCode}.${themeCode}_${userData.name || userData.nombre || 'USUARIO'}`;

            const finalQuizName = exportQuizName.trim() || quizData.name || quizData.titulo || `Quiz: ${selectedQuizKey}`;

            // 4. Crear el cuestionario en Firestore shared_vault/{uid}/quizzes
            const vaultData = {
                standardizedId,
                hierarchyCode: userHCode,
                corpsCode: userCCode,
                specialtyCode: userSCode,
                areaId: quizData.areaId || '3',
                themeCode: themeCode,
                authorName: userData.name || userData.nombre || 'Usuario',
                authorId: selectedUid,
                name: finalQuizName,
                questionCount: quizQuestions.length,
                difficulty: quizData.difficulty || 'medium',
                timestamp: serverTimestamp(),
                isVault: true,
                tipo: 'tecnica'
            };

            const userVaultRef = collection(db, 'shared_vault', selectedUid, 'quizzes');
            const vaultRef = await addDoc(userVaultRef, vaultData);

            // 5. Copiar las preguntas al subcollection
            const questionsRef = collection(db, 'shared_vault', selectedUid, 'quizzes', vaultRef.id, 'questions');

            let index = 0;
            const totalQuestions = quizQuestions.length;

            for (const q of quizQuestions) {
                index++;
                setExportProgress(Math.round((index / totalQuestions) * 100));

                if (!q.pregunta && !q.question) continue;

                let respuestasMap = q.respuestas || {};
                if (Array.isArray(q.options)) {
                    respuestasMap = {};
                    q.options.forEach((opt, idx) => {
                        const respId = 1000 + idx;
                        respuestasMap[respId] = {
                            id: respId,
                            respuesta: opt || 'Opción',
                            correcta: idx === q.correctAnswer ? 1 : 0
                        };
                    });
                }

                await addDoc(questionsRef, {
                    pregunta: q.pregunta || q.question || 'Pregunta sin texto',
                    respuestas: respuestasMap,
                    respuesta_correcta: q.respuesta_correcta || (Array.isArray(q.options) ? q.options[q.correctAnswer] : '') || '',
                    explicacion: q.explicacion || q.explanation || '',
                    dificultad: q.dificultad || q.difficulty || 'medium',
                    tema: quizData.temaName || themeCode,
                    area: quizData.areaName || 'Especialidad',
                    addedAt: serverTimestamp()
                });
            }

            setExportMessage('Quiz exportado exitosamente a la Bóveda Técnica.');
        } catch (err) {
            console.error('Error exporting quiz:', err);
            setExportMessage('Error al exportar el quiz: ' + err.message);
        } finally {
            setIsExporting(false);
        }
    };

    const renderContent = () => {
        if (activeTab === 'dashboard') {
            // Filtrado por categoría seleccionada y por término de búsqueda
            const filteredCategories = categories.map(cat => {
                if (selectedCategoryFilter !== 'ALL' && cat.title !== selectedCategoryFilter) {
                    return { ...cat, items: [] };
                }

                if (!searchTerm.trim()) return cat;

                const q = searchTerm.toLowerCase();
                const matchingItems = cat.items.filter(item =>
                    item.label.toLowerCase().includes(q) ||
                    (item.description && item.description.toLowerCase().includes(q)) ||
                    cat.title.toLowerCase().includes(q)
                );

                return { ...cat, items: matchingItems };
            }).filter(cat => cat.items.length > 0);

            // Lista plana para la vista en Lista
            const allUniqueItems = [];
            const seenKeys = new Set();

            categories.forEach(cat => {
                if (selectedCategoryFilter !== 'ALL' && cat.title !== selectedCategoryFilter) return;

                cat.items.forEach(item => {
                    const key = item.id + '-' + cat.title;
                    if (!seenKeys.has(key)) {
                        seenKeys.add(key);

                        if (searchTerm.trim()) {
                            const q = searchTerm.toLowerCase();
                            const matchLabel = item.label.toLowerCase().includes(q);
                            const matchDesc = item.description && item.description.toLowerCase().includes(q);
                            const matchCat = cat.title.toLowerCase().includes(q);
                            if (!matchLabel && !matchDesc && !matchCat) return;
                        }

                        allUniqueItems.push({
                            ...item,
                            categoryTitle: cat.title,
                            categoryIcon: cat.icon
                        });
                    }
                });
            });

            return (
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {/* Encabezado y Barra de Controles Tácticos */}
                    <div className="admin-dashboard-header">
                        <div className="admin-dashboard-header-top">
                            <div>
                                <h2 className="admin-dashboard-title">
                                    ⚡ Módulos y Herramientas del Administrador
                                </h2>
                                <p className="admin-dashboard-subtitle">
                                    Acceso rápido a la gestión de usuarios, licencias, contenido, simulación y ajustes del sistema.
                                </p>
                            </div>
                        </div>

                        {/* Barra de Filtros, Buscador y Selector de Modo de Vista */}
                        <div className="admin-dashboard-controls-bar">
                            {/* Buscador de Módulos */}
                            <div className="admin-search-box">
                                <span className="search-icon">🔍</span>
                                <input
                                    type="text"
                                    placeholder="Buscar herramienta (ej. licencias, usuarios, quizzes, OCR...)"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="admin-search-input"
                                />
                                {searchTerm && (
                                    <button className="clear-search-btn" onClick={() => setSearchTerm('')}>✕</button>
                                )}
                            </div>

                            {/* Acciones de Diseño y Selector de Modo de Vista (Cuadrícula / Lista) */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <button
                                    className="reset-layout-btn"
                                    onClick={handleResetLayout}
                                    title="Restablecer el orden por defecto de todas las categorías"
                                >
                                    ↺ Restablecer Orden
                                </button>

                                <div className="admin-view-toggle">
                                    <button
                                        className={`view-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
                                        onClick={() => handleViewModeChange('grid')}
                                        title="Vista en Cuadrícula"
                                    >
                                        <span className="toggle-icon">🔲</span>
                                        <span className="toggle-label">Cuadrícula</span>
                                    </button>
                                    <button
                                        className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
                                        onClick={() => handleViewModeChange('list')}
                                        title="Vista en Lista Compacta"
                                    >
                                        <span className="toggle-icon">☰</span>
                                        <span className="toggle-label">Lista</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Chips / Tabs de Categorías */}
                        <div className="admin-category-tabs">
                            <button
                                className={`category-tab-btn ${selectedCategoryFilter === 'ALL' ? 'active' : ''}`}
                                onClick={() => setSelectedCategoryFilter('ALL')}
                            >
                                🌐 Todas las Herramientas
                            </button>
                            {categories.map(cat => (
                                <button
                                    key={'tab-' + cat.title}
                                    className={`category-tab-btn ${selectedCategoryFilter === cat.title ? 'active' : ''}`}
                                    onClick={() => setSelectedCategoryFilter(cat.title)}
                                >
                                    {cat.icon} {cat.title} ({cat.items.length})
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* VISTA EN CUADRÍCULA (GRID) */}
                    {viewMode === 'grid' && (
                        filteredCategories.length > 0 ? (
                            <div className="admin-dashboard-grid">
                                {filteredCategories.map((category, idx) => (
                                    <div
                                        key={category.title}
                                        className={`dashboard-category ${category.fullWidth ? 'category-full' : ''} ${category.twoColumns ? 'category-2-cols' : ''} ${dragOverCategoryIdx === idx ? 'drag-target-over' : ''}`}
                                        draggable={!searchTerm && selectedCategoryFilter === 'ALL'}
                                        onDragStart={(e) => handleDragStartCategory(e, idx)}
                                        onDragOver={(e) => handleDragOverCategory(e, idx)}
                                        onDragLeave={(e) => handleDragLeaveCategory(e, idx)}
                                        onDrop={(e) => handleDropOnCategory(e, idx)}
                                    >
                                        <div className="category-header-row">
                                            <h3 className="category-header-title">
                                                <span className="drag-handle-category" title="Arrastrar para mover categoría completa">⋮⋮</span>
                                                <span className="category-header-icon">{category.icon}</span>
                                                <span>{category.title}</span>
                                            </h3>
                                            <span className={`category-badge-pill ${getCategoryBadgeClass(category.title)}`}>
                                                {category.items.length} {category.items.length === 1 ? 'módulo' : 'módulos'}
                                            </span>
                                        </div>

                                        <div className="category-items">
                                            {category.items.map((item, itemIdx) => (
                                                <div
                                                    key={item.id + '-' + category.title}
                                                    className={`dashboard-card ${draggedItem?.item.id === item.id ? 'dragging' : ''}`}
                                                    draggable={!searchTerm && selectedCategoryFilter === 'ALL'}
                                                    onDragStart={(e) => handleDragStartItem(e, item, idx, itemIdx)}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={(e) => handleDropOnItem(e, item, idx, itemIdx)}
                                                    onClick={() => {
                                                        if (item.action) item.action();
                                                        else if (item.route) navigate(item.route);
                                                        else setActiveTab(item.id);
                                                    }}
                                                    style={{
                                                        borderTop: item.id === 'quizzes' ? '3px solid var(--admin-btn-custom)' :
                                                            item.id === 'anniversary' ? `3px solid ${anniversaryActive ? '#4caf50' : '#f44336'}` :
                                                                ['licenses', 'devices', 'licenses-consolidated'].includes(item.id) ? '3px solid #4a90e2' : '3px solid rgba(197, 160, 89, 0.4)'
                                                    }}
                                                >
                                                    {/* Barra superior de la tarjeta con Grip y Badge */}
                                                    <div className="card-top-bar">
                                                        <div className="card-top-left">
                                                            <span className="card-drag-grip" title="Arrastrar para mover entre categorías">⋮⋮</span>
                                                            <span className={`card-category-tag ${getCategoryBadgeClass(category.title)}`}>
                                                                {category.title}
                                                            </span>
                                                        </div>
                                                        <div className="card-arrow-trigger">
                                                            <span>➔</span>
                                                        </div>
                                                    </div>

                                                    {/* Contenido principal de la tarjeta */}
                                                    <div className="card-main-content">
                                                        <div className="card-icon" style={{ color: 'var(--admin-btn-custom)' }}>
                                                            {item.icon}
                                                        </div>
                                                        <div className="card-info">
                                                            <h4 style={{ color: 'var(--admin-text-custom)' }}>{item.label}</h4>
                                                            <p>{item.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                            {category.items.length === 0 && (
                                                <div className="empty-category-dropzone">
                                                    📥 Arrastra aquí cualquier herramienta para incluirla en esta categoría
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="admin-empty-results">
                                <span>🔍</span>
                                <p style={{ fontWeight: 'bold' }}>No se encontraron herramientas con "{searchTerm}"</p>
                                <p style={{ fontSize: '0.85rem' }}>Prueba con otro término de búsqueda o selecciona otra categoría.</p>
                            </div>
                        )
                    )}

                    {/* VISTA EN LISTA (LIST) */}
                    {viewMode === 'list' && (
                        <div className="admin-list-view-container">
                            {allUniqueItems.length > 0 ? (
                                <div className="admin-list-card">
                                    <div style={{ overflowX: 'auto' }}>
                                        <table className="admin-list-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '300px' }}>Herramienta / Módulo</th>
                                                    <th style={{ width: '220px' }}>Categoría</th>
                                                    <th>Descripción Funcional</th>
                                                    <th style={{ width: '130px', textAlign: 'right' }}>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {allUniqueItems.map((item, idx) => (
                                                    <tr
                                                        key={item.id + '-list-' + idx}
                                                        className="admin-list-row"
                                                        onClick={() => {
                                                            if (item.action) item.action();
                                                            else if (item.route) navigate(item.route);
                                                            else setActiveTab(item.id);
                                                        }}
                                                    >
                                                        <td>
                                                            <div className="module-title-cell">
                                                                <div className="module-icon-box">
                                                                    {item.icon}
                                                                </div>
                                                                <div>
                                                                    <div style={{ color: 'var(--admin-text-custom)' }}>{item.label}</div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <span className={`category-badge-pill ${getCategoryBadgeClass(item.categoryTitle)}`}>
                                                                {item.categoryIcon} {item.categoryTitle}
                                                            </span>
                                                        </td>
                                                        <td style={{ color: 'rgba(181, 200, 216, 0.85)', fontSize: '0.82rem' }}>
                                                            {item.description}
                                                        </td>
                                                        <td style={{ textAlign: 'right' }}>
                                                            <button
                                                                className="module-action-btn"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (item.action) item.action();
                                                                    else if (item.route) navigate(item.route);
                                                                    else setActiveTab(item.id);
                                                                }}
                                                            >
                                                                Abrir ➔
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="admin-empty-results">
                                    <span>🔍</span>
                                    <p style={{ fontWeight: 'bold' }}>No se encontraron herramientas en la lista</p>
                                    <p style={{ fontSize: '0.85rem' }}>Prueba borrando el filtro de búsqueda o cambiando de categoría.</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div className="tab-view-container tab-content-panel">
                <div className="tab-view-header">
                    <button className="back-to-dashboard" onClick={() => setActiveTab('dashboard')}>
                        ⬅️ Volver
                    </button>
                    <h2>{activeTab.toUpperCase().replace('-', ' ')}</h2>
                </div>
                <div className="active-panel-container">
                    {activeTab === 'live-users' && <AdminLiveUsersPanel />}
                    {activeTab === 'cursos-vortex-admin' && <AdminCursosManagement />}
                    {activeTab === 'licenses-consolidated' && <AdminLicensesPanel />}
                    {activeTab === 'study-material' && <AdminStudyMaterial />}
                    {activeTab === 'notifications' && <NotificationAdminPanel />}
                    {activeTab === 'admins' && <TemporaryAdminPanel />}
                    {activeTab === 'devices' && <DeviceAdminPanel />}
                    {activeTab === 'rtdb' && <RTDBViewerPanel />}
                    {activeTab === 'versions' && <VersionTrackingPanel />}
                    {activeTab === 'anniversary' && <AnniversaryAdminPanel anniversaryActive={anniversaryActive} onToggleAnniversary={handleToggleAnniversary} />}
                    {activeTab === 'yt-downloader' && <YouTubeDownloaderPanel />}
                    {activeTab === 'tutorials-admin' && <AdminTutorialsPanel />}
                    {activeTab === 'assign-profile' && <AdminAssignProfilePanel />}
                    {activeTab === 'rebuild-preguntas' && <AdminRebuildPreguntasPorTema />}
                    {activeTab === 'ocr-scanner' && <AdminOCRPanel />}
                    {activeTab === 'shadow' && <AdminShadowPanel />}
                    {activeTab === 'seed-universities' && <AdminSeedUniversities />}
                    {activeTab === 'user-quizzes' && (
                        <div className="user-quizzes-layout">
                            {/* Left card: User list */}
                            <div className="admin-panel-card user-quizzes-user-list">
                                <h3 style={{ margin: '0 0 4px 0', fontSize: '1.1rem', color: 'var(--admin-text-custom)' }}>👤 Usuarios con Cuestionarios</h3>
                                <p style={{ color: '#888', fontSize: '0.8rem', marginBottom: '14px' }}>{usersList.length} usuarios encontrados — selecciona uno para ver sus cuestionarios.</p>
                                <div className="user-list-scroll">
                                    {usersList.map(usr => (
                                        <div
                                            key={usr.uid}
                                            onClick={() => {
                                                setSelectedUid(usr.uid);
                                                setSelectedQuizKey('');
                                                setQuizQuestions([]);
                                                setExportMessage('');
                                                setUserQuizzesError('');
                                            }}
                                            style={{
                                                background: selectedUid === usr.uid
                                                    ? 'linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(59, 130, 246, 0.15))'
                                                    : 'rgba(255,255,255,0.04)',
                                                border: selectedUid === usr.uid
                                                    ? '2px solid #38bdf8'
                                                    : '1px solid rgba(255,255,255,0.08)',
                                                borderRadius: '12px',
                                                padding: '12px 14px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                display: 'grid',
                                                gridTemplateColumns: 'auto 1fr auto',
                                                gap: '12px',
                                                alignItems: 'center'
                                            }}
                                            onMouseEnter={e => { if (selectedUid !== usr.uid) { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.borderColor = 'rgba(56,189,248,0.3)'; }}}
                                            onMouseLeave={e => { if (selectedUid !== usr.uid) { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}}
                                        >
                                            <div style={{
                                                width: '38px', height: '38px',
                                                borderRadius: '10px',
                                                background: selectedUid === usr.uid ? '#38bdf8' : 'rgba(255,255,255,0.06)',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontSize: '1.1rem', flexShrink: 0
                                            }}>
                                                {usr.hierarchy === 'MRO' ? '🔵' : usr.hierarchy === 'CABO' ? '🟢' : '🟡'}
                                            </div>
                                            <div style={{ minWidth: 0 }}>
                                                <div style={{ fontWeight: 600, fontSize: '0.9rem', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {usr.name}
                                                </div>
                                                <div style={{ fontSize: '0.75rem', color: '#94a3b8', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                                                    <span style={{ color: '#fbbf24' }}>{usr.hierarchy}</span>
                                                    <span>{usr.corpsCode}</span>
                                                    <span>{usr.specialtyCode}</span>
                                                </div>
                                            </div>
                                            <div style={{ fontSize: '0.65rem', color: '#64748b', textAlign: 'right', fontFamily: 'monospace', maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                {usr.uid.slice(0, 8)}...
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Right card: Selected user details + quizzes */}
                            <div className="admin-panel-card user-quizzes-detail">
                                {!selectedUid ? (
                                    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#64748b' }}>
                                        <div style={{ fontSize: '3rem', marginBottom: '12px' }}>👆</div>
                                        <p style={{ fontSize: '0.95rem' }}>Selecciona un usuario de la lista para ver sus datos y cuestionarios.</p>
                                    </div>
                                ) : (() => {
                                    const usr = usersList.find(u => u.uid === selectedUid);
                                    return usr ? (
                                        <>
                                            {/* User info card */}
                                            <div style={{
                                                background: 'linear-gradient(135deg, #0f2027, #203a43, #2c5364)',
                                                border: '1px solid #38bdf8',
                                                borderRadius: '10px',
                                                padding: '14px 18px',
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr',
                                                gap: '8px 20px',
                                                fontSize: '0.82rem',
                                                color: '#e0f2fe'
                                            }}>
                                                <div><span style={{ color: '#7dd3fc', fontWeight: 'bold' }}>UID:</span><br /><code style={{ fontSize: '0.78rem', wordBreak: 'break-all' }}>{usr.uid}</code></div>
                                                <div><span style={{ color: '#7dd3fc', fontWeight: 'bold' }}>Nombre:</span><br />{usr.name}</div>
                                                <div><span style={{ color: '#7dd3fc', fontWeight: 'bold' }}>Jerarquía:</span><br /><strong style={{ color: '#fbbf24' }}>{usr.hierarchy}</strong></div>
                                                <div><span style={{ color: '#7dd3fc', fontWeight: 'bold' }}>Cuerpo / Servicio:</span><br />
                                                    <span style={{ color: '#34d399' }}>{usr.cuerpoServicio || <em style={{ color: '#999' }}>No registrado</em>}</span>
                                                    {usr.corpsCode ? <code style={{ marginLeft: '6px', background: '#1e3a5f', padding: '1px 5px', borderRadius: '4px' }}>{usr.corpsCode}</code> : null}
                                                </div>
                                                <div style={{ gridColumn: '1 / -1' }}><span style={{ color: '#7dd3fc', fontWeight: 'bold' }}>Especialidad:</span><br />
                                                    <span style={{ color: '#d8b978' }}>{usr.especialidad || <em style={{ color: '#999' }}>No registrada</em>}</span>
                                                    {usr.specialtyCode ? <code style={{ marginLeft: '6px', background: '#2e1f5e', padding: '1px 5px', borderRadius: '4px' }}>{usr.specialtyCode}</code> : null}
                                                </div>
                                            </div>

                                            {/* Quizzes list */}
                                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                <label  className="adm-label">
                                                    📋 Cuestionarios ({userQuizzes.length})
                                                </label>
                                                {userQuizzesLoading ? (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                        Cargando...
                                                    </div>
                                                ) : userQuizzesError ? (
                                                    <div style={{ textAlign: 'center', padding: '16px', color: '#ef4444', fontSize: '0.82rem', background: 'rgba(239,68,68,0.1)', borderRadius: '8px', border: '1px solid rgba(239,68,68,0.3)' }}>
                                                        {userQuizzesError}
                                                    </div>
                                                ) : userQuizzes.length === 0 ? (
                                                    <div style={{ textAlign: 'center', padding: '20px', color: '#64748b', fontSize: '0.85rem' }}>
                                                        Este usuario no ha creado cuestionarios aún.
                                                    </div>
                                                ) : (
                                                    <div className="quizzes-scroll">
                                                        {userQuizzes.map(quiz => (
                                                            <div
                                                                key={quiz.id}
                                                                onClick={() => { setSelectedQuizKey(quiz.id); setExportMessage(''); setQuizQuestionsError(''); }}
                                                                style={{
                                                                    background: selectedQuizKey === quiz.id
                                                                        ? 'rgba(56, 189, 248, 0.15)'
                                                                        : 'rgba(255,255,255,0.04)',
                                                                    border: selectedQuizKey === quiz.id
                                                                        ? '1px solid #38bdf8'
                                                                        : '1px solid rgba(255,255,255,0.06)',
                                                                    borderRadius: '8px',
                                                                    padding: '10px 12px',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.2s',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center'
                                                                }}
                                                                onMouseEnter={e => { if (selectedQuizKey !== quiz.id) { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}}
                                                                onMouseLeave={e => { if (selectedQuizKey !== quiz.id) { e.currentTarget.style.background = 'rgba(255,255,255,0.04)'; }}}
                                                            >
                                                                <span style={{ fontSize: '0.85rem', color: '#fff', fontWeight: selectedQuizKey === quiz.id ? 600 : 400 }}>
                                                                    {quiz.name || quiz.titulo || quiz.id}
                                                                </span>
                                                                <span style={{ fontSize: '0.75rem', color: '#94a3b8', background: 'rgba(255,255,255,0.06)', padding: '2px 8px', borderRadius: '10px' }}>
                                                                    {quiz.questionCount || 0} preguntas
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>

                                             {/* Quiz name editing before export */}
                                             {selectedQuizKey && (
                                                 <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '8px' }}>
                                                     <label  className="adm-label">
                                                         ✏️ Nombre del Cuestionario en Bóveda:
                                                     </label>
                                                     <input 
                                                         type="text" 
                                                         value={exportQuizName} 
                                                         onChange={(e) => setExportQuizName(e.target.value)}
                                                         style={{ 
                                                             padding: '10px 12px', 
                                                             borderRadius: '8px', 
                                                             border: '1px solid #38bdf8', 
                                                             background: '#0f172a', 
                                                             color: '#fff',
                                                             fontSize: '0.85rem',
                                                             outline: 'none',
                                                             boxShadow: '0 0 4px rgba(56, 189, 248, 0.2)'
                                                         }}
                                                         placeholder="Ingresa el nombre descriptivo del cuestionario..."
                                                     />
                                                 </div>
                                             )}

                                            {/* Export button */}
                                            <button
                                                onClick={handleExportQuiz}
                                                disabled={!selectedQuizKey || isExporting}
                                                 className="adm-btn adm-btn--primary"
                                            >
                                                {isExporting ? 'Exportando...' : 'Exportar a Bóveda Técnica'}
                                            </button>

                                            {/* Progress Bar */}
                                            {isExporting && (
                                                <div style={{
                                                    marginTop: '6px',
                                                    background: 'rgba(15, 23, 42, 0.6)',
                                                    borderRadius: '8px',
                                                    padding: '10px 12px',
                                                    border: '1px solid rgba(56, 189, 248, 0.2)'
                                                }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.75rem', color: '#94a3b8', marginBottom: '6px' }}>
                                                        <span>Copiando preguntas a la Bóveda...</span>
                                                        <span style={{ fontWeight: 'bold', color: '#38bdf8' }}>{exportProgress}%</span>
                                                    </div>
                                                    <div style={{ width: '100%', height: '6px', background: '#1e293b', borderRadius: '10px', overflow: 'hidden' }}>
                                                        <div style={{
                                                            width: `${exportProgress}%`,
                                                            height: '100%',
                                                            background: 'linear-gradient(90deg, #38bdf8, #3b82f6)',
                                                            borderRadius: '10px',
                                                            transition: 'width 0.15s ease-out'
                                                        }}></div>
                                                    </div>
                                                </div>
                                            )}

                                            {exportMessage && (
                                                <div style={{
                                                    padding: '10px',
                                                    borderRadius: '8px',
                                                    background: exportMessage.includes('exitosamente') ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                                                    color: exportMessage.includes('exitosamente') ? '#10b981' : '#ef4444',
                                                    fontSize: '0.85rem',
                                                    border: exportMessage.includes('exitosamente') ? '1px solid #10b981' : '1px solid #ef4444',
                                                    whiteSpace: 'pre-line'
                                                }}>
                                                    {exportMessage}
                                                </div>
                                            )}
                                        </>
                                    ) : null;
                                })()}
                            </div>

                            {/* Questions panel - full width below */}
                            {(selectedQuizKey && (quizQuestionsLoading || quizQuestionsError || quizQuestions.length > 0)) && (
                                <div className="admin-panel-card user-quizzes-questions">
                                    <label  style={{  display: 'block',  marginBottom: '10px' }} className="adm-label">
                                        Preguntas del Cuestionario ({quizQuestions.length}):
                                    </label>
                                    {quizQuestionsLoading ? (
                                        <div style={{ textAlign: 'center', padding: '20px', color: '#94a3b8', fontSize: '0.85rem' }}>
                                            Cargando preguntas...
                                        </div>
                                    ) : quizQuestionsError ? (
                                        <div style={{ textAlign: 'center', padding: '16px', color: '#ef4444', fontSize: '0.82rem', background: 'rgba(239,68,68,0.1)', borderRadius: '8px', border: '1px solid rgba(239,68,68,0.3)' }}>
                                            {quizQuestionsError}
                                        </div>
                                    ) : (
                                        <div className="questions-scroll">
                                            {quizQuestions.map((q, idx) => (
                                                <div key={'qq-' + idx} style={{
                                                    borderBottom: idx < quizQuestions.length - 1 ? '1px solid rgba(255,255,255,0.06)' : 'none',
                                                    paddingBottom: '10px',
                                                    color: '#e2e8f0'
                                                }}>
                                                    <strong>{idx + 1}. {q.pregunta || q.question}</strong>
                                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px', marginTop: '5px', fontSize: '0.85rem' }}>
                                                        {q.respuestas && typeof q.respuestas === 'object' ? (
                                                            Object.values(q.respuestas).map((resp, rIdx) => (
                                                                <div key={'resp-' + (resp.id || rIdx)} style={{ color: resp.correcta ? '#10b981' : '#94a3b8', fontWeight: resp.correcta ? 'bold' : 'normal' }}>
                                                                    • {resp.respuesta} {resp.correcta ? '(✓)' : ''}
                                                                </div>
                                                            ))
                                                        ) : q.options && Array.isArray(q.options) ? (
                                                            q.options.map((opt, oIdx) => (
                                                                <div key={'opt-' + oIdx} style={{ color: oIdx === q.correctAnswer ? '#10b981' : '#94a3b8', fontWeight: oIdx === q.correctAnswer ? 'bold' : 'normal' }}>
                                                                    • {opt} {oIdx === q.correctAnswer ? '(✓)' : ''}
                                                                </div>
                                                            ))
                                                        ) : null}
                                                    </div>
                                                    {(q.explicacion || q.explanation) && (
                                                        <p style={{ margin: '5px 0 0 0', fontSize: '0.8rem', color: '#94a3b8', fontStyle: 'italic' }}>
                                                            Explicación: {q.explicacion || q.explanation}
                                                        </p>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            {renderContent()}
        </div>
    );
};

export default AdminPanel;